<template>
  <span>
    <v-skeleton-loader v-if="!hasAverage" class="check-average-positions-loader" type="chip"></v-skeleton-loader>
    <span v-else>
      <serp-position
          v-if="getAverage() !== null"
          :value="getAverage()"
          badge="true"
          size="small">
      </serp-position>
      <serp-position
          v-else
          badge="true"
          size="small"
          value="+30">
      </serp-position>
    </span>
  </span>
</template>

<script>
import SerpPosition from '@/views/Common/Components/Serp/SerpPosition'

export default {
  name: 'CheckAveragePositions',
  components: {SerpPosition},
  props: ['datacenters'],
  computed: {
    hasAverage() {
      return this.datacenters && Object.values(this.datacenters).filter(position => position !== null).length > 0
    },
  },
  methods: {
    getPositions() {
      const positions = []

      Object.values(this.datacenters).forEach(position => {
        if (position !== null && position !== false && position !== 0) positions.push(position)
      })

      return positions
    },
    getAverage() {
      const positions = this.getPositions()

      const sum = positions.reduce((a, b) => a + b, 0)
      const avg = sum / positions.length || null
      return avg === null ? null : Math.round(avg * 10) / 10
    },
  }
}
</script>

<style>
.check-average-positions-loader > div {
  height: 24px;
  width: 32px;
}
</style>